"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TransportationReportPageActions;
(function (TransportationReportPageActions) {
    TransportationReportPageActions["DataLoaded"] = "DataLoaded";
})(TransportationReportPageActions || (TransportationReportPageActions = {}));
exports.default = TransportationReportPageActions;
